module.exports = __webpack_public_path__ + "static/Tiled-Ads-8137570ba1f5f628bea837fd38ba6f9d.jpg";